import React, { useCallback, useEffect, useState } from 'react';
import { Snackbar } from '@mui/material';
import SnackbarStore, {
  SnackbarProps,
  SnackbarState,
} from '../../stores/observables/SnackbarStore';
import { DRAWER_Z_INDEX } from '../../definitions/constants';

const withSnackbar =
  (ComponentDefinition: React.ComponentType) => (props: any) => {
    const [showSnackbar, setShowSnackbar] = useState(false);
    const [action, setAction] = useState<React.ReactNode>();
    const [message, setMessage] = useState<React.ReactNode>();
    const [snackbarProps, setSnackbarProps] = useState<SnackbarProps>();

    useEffect(() => {
      subscribeSnackbar();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const subscribeSnackbar = useCallback(() => {
      SnackbarStore.getObservable().subscribe(
        (snackbarState: SnackbarState) => {
          setAction(snackbarState.action);
          setMessage(snackbarState.message);
          setSnackbarProps(snackbarState.SnackbarProps);
          setShowSnackbar(!!snackbarState?.message);
        }
      );
    }, []);

    const resetState = useCallback(() => {
      setAction(undefined);
      setMessage(undefined);
      setSnackbarProps(undefined);
    }, []);

    const onSnackbarClosed = useCallback(
      (_: any, reason?: string) => {
        if (reason === 'clickaway') {
          return;
        }

        setShowSnackbar(false);
        // waiting a bit before resetting the state so the exit animation is done properly
        setTimeout(() => resetState(), 250);
      },
      [resetState]
    );

    return (
      <>
        <ComponentDefinition {...props} />
        <Snackbar
          action={action}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          autoHideDuration={4000}
          message={message}
          onClose={onSnackbarClosed}
          open={showSnackbar}
          style={{ zIndex: DRAWER_Z_INDEX + 1 }}
          {...snackbarProps}
        />
      </>
    );
  };

export default withSnackbar;
